<form [formGroup]="locationForm" class="location-form">
  <ion-row class="wrapper ion-margin-bottom ion-margin-top">
    <!-- Location Code -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.LOCATION_CODE"
          [minLength]="3"
          [maxLength]="10"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_NUMBER_NO_SPACE"
          [control]="'locationCode'"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Location Name -->
    <ion-col size="auto">
      <div class="form-group large-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.LOCATION_NAME"
          [maxLength]="30"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_BASIC_PUNCT"
          [control]="'locationName'"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- PKG Slic -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.PKG_SLIC"
          [minLength]="4"
          [maxLength]="5"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_NUMBER_NO_SPACE"
          [control]="'pkgSlic'"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Hub Slic -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.HUB_SLIC"
          [minLength]="4"
          [maxLength]="5"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_NUMBER_NO_SPACE"
          [control]="'hubSlic'"
          [hasRequiredSign]="false"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Mnemonic' -->
    <ion-col size="auto" class="no-pr">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.MNEMONIC"
          [minLength]="4"
          [maxLength]="5"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_NUMBER_NO_SPACE"
          [control]="'mnemonic'"
          [hasRequiredSign]="false"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>
  </ion-row>

  <ion-row class="wrapper">
    <!-- Region Code -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.REGION"
          [maxLength]="2"
          [form]="locationForm"
          [regexType]="REGEX.NUMBER_ONLY"
          [control]="'region'"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- District Code -->
    <ion-col size="auto">
      <div class="form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.DISTRICT"
          [maxLength]="2"
          [form]="locationForm"
          [regexType]="REGEX.NUMBER_ONLY"
          [control]="'district'"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- OSP Id -->
    <ion-col size="auto">
      <div class="form-group optional-form-group small-input-group">
        <app-form-text-field
          [labelText]="CONSTANTS.OSP_ID"
          [maxLength]="10"
          [form]="locationForm"
          [regexType]="REGEX.ALPHABET_NUMBER"
          [control]="'ospId'"
          [hasRequiredSign]="false"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </div>
    </ion-col>

    <!-- Location setup -->
    <ion-col size="auto">
      <div class="form-group optional-form-group select-form-group">
        <app-form-select
          [label]="CONSTANTS.LOCATION_SETUP"
          [options]="locationSetupOption"
          formControlName="locationSetup"
          [required]="false"
          [customClass]="'alt-height'"
          [dropdownPosition]="DropdownPosition.TOP"
        >
        </app-form-select>
      </div>
    </ion-col>

    <!-- Timezone -->
    <ion-col size="auto">
      <div class="form-group timezone-input-group select-form-group">
        <app-form-select
          [label]="CONSTANTS.TIMEZONE"
          [options]="timezoneOptionList"
          formControlName="gmtTimeZone"
          [customClass]="'alt-height'"
          [required]="true"
          [dropdownPosition]="DropdownPosition.TOP"
        >
        </app-form-select>
      </div>
    </ion-col>
  </ion-row>

  <!-- footer -->
  <app-footer-action-bar
    [form]="locationForm"
    [edit]="edit"
    [btnEnabled]="formState.canSubmit"
    [resetBtnEnabled]="formState.canReset"
    (submitBtnClick)="submitLocationForm()"
    (resetBtnClick)="resetLocationForm()"
  ></app-footer-action-bar>
</form>
